var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _rect68, _rect69, _rect70, _rect71, _rect72, _rect73, _rect74, _rect75, _rect76, _rect77, _rect78;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArtVideoArtifacts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1260,
    height: 810,
    viewBox: "0 0 1260 810",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 9,
    transform: "matrix(1 0 0 -1 3 339)",
    fill: "#E9ABE1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 4,
    transform: "matrix(1 0 0 -1 3 385)",
    fill: "#E9ABE1"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 4,
    transform: "matrix(1 0 0 -1 77 385)",
    fill: "#E9ABE1"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 4,
    transform: "matrix(1 0 0 -1 151 385)",
    fill: "#E9ABE1"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 8,
    transform: "matrix(1 0 0 -1 157 252)",
    fill: "#E9ABE1"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 2,
    transform: "matrix(1 0 0 -1 156 208)",
    fill: "#E9ABE1"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 2,
    transform: "matrix(1 0 0 -1 78 207)",
    fill: "#E9ABE1"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 2,
    transform: "matrix(1 0 0 -1 78 164)",
    fill: "#E9ABE1"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 2,
    transform: "matrix(1 0 0 -1 0 473)",
    fill: "#E9ABE1"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 2,
    transform: "matrix(1 0 0 -1 0 517)",
    fill: "#E9ABE1"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 2,
    transform: "matrix(1 0 0 -1 0 561)",
    fill: "#E9ABE1"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 2,
    transform: "matrix(1 0 0 -1 1 600)",
    fill: "#E9ABE1"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 2,
    transform: "matrix(1 0 0 -1 1 605)",
    fill: "#E9ABE1"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 2,
    transform: "matrix(1 0 0 -1 12 605)",
    fill: "#E9ABE1"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 2,
    transform: "matrix(1 0 0 -1 12 600)",
    fill: "#E9ABE1"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 1257,
    y: 597,
    width: 3,
    height: 2,
    transform: "rotate(-180 1257 597)",
    fill: "#E9ABE1"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 1022,
    y: 597,
    width: 3,
    height: 2,
    transform: "rotate(-180 1022 597)",
    fill: "#E9ABE1"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 1247,
    y: 597,
    width: 3,
    height: 2,
    transform: "rotate(-180 1247 597)",
    fill: "#E9ABE1"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 1012,
    y: 597,
    width: 3,
    height: 2,
    transform: "rotate(-180 1012 597)",
    fill: "#E9ABE1"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 1257,
    y: 592,
    width: 3,
    height: 2,
    transform: "rotate(-180 1257 592)",
    fill: "#E9ABE1"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 1022,
    y: 592,
    width: 3,
    height: 2,
    transform: "rotate(-180 1022 592)",
    fill: "#E9ABE1"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 1247,
    y: 592,
    width: 3,
    height: 2,
    transform: "rotate(-180 1247 592)",
    fill: "#E9ABE1"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 1012,
    y: 592,
    width: 3,
    height: 2,
    transform: "rotate(-180 1012 592)",
    fill: "#E9ABE1"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 1258,
    y: 552,
    width: 3,
    height: 2,
    transform: "rotate(-180 1258 552)",
    fill: "#E9ABE1"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 1179,
    y: 553,
    width: 3,
    height: 2,
    transform: "rotate(-180 1179 553)",
    fill: "#E9ABE1"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 865,
    y: 332,
    width: 7,
    height: 7,
    transform: "rotate(-180 865 332)",
    fill: "#E9ABE1"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 1,
    transform: "matrix(-1 0 0 1 865 315)",
    fill: "#E9ABE1"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 1,
    transform: "matrix(-1 0 0 1 865 311)",
    fill: "#E9ABE1"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 1180,
    y: 597,
    width: 3,
    height: 2,
    transform: "rotate(-180 1180 597)",
    fill: "#E9ABE1"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 944,
    y: 200,
    width: 3,
    height: 2,
    transform: "rotate(-180 944 200)",
    fill: "#E9ABE1"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 790,
    y: 199,
    width: 3,
    height: 2,
    transform: "rotate(-180 790 199)",
    fill: "#E9ABE1"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 1103,
    y: 597,
    width: 3,
    height: 2,
    transform: "rotate(-180 1103 597)",
    fill: "#E9ABE1"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 867,
    y: 200,
    width: 3,
    height: 2,
    transform: "rotate(-180 867 200)",
    fill: "#E9ABE1"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 713,
    y: 199,
    width: 3,
    height: 2,
    transform: "rotate(-180 713 199)",
    fill: "#E9ABE1"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 1102,
    y: 552,
    width: 3,
    height: 2,
    transform: "rotate(-180 1102 552)",
    fill: "#E9ABE1"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 1256,
    y: 653,
    width: 79,
    height: 2,
    transform: "rotate(-180 1256 653)",
    fill: "#E9ABE1"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 1259,
    y: 509,
    width: 9,
    height: 2,
    transform: "rotate(-180 1259 509)",
    fill: "#E9ABE1"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 1260,
    y: 464,
    width: 9,
    height: 2,
    transform: "rotate(-180 1260 464)",
    fill: "#E9ABE1"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 518,
    width: 3,
    height: 2,
    fill: "#E9ABE1"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 445,
    y: 518,
    width: 3,
    height: 2,
    fill: "#E9ABE1"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 220,
    y: 518,
    width: 3,
    height: 2,
    fill: "#E9ABE1"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 455,
    y: 518,
    width: 3,
    height: 2,
    fill: "#E9ABE1"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 523,
    width: 3,
    height: 2,
    fill: "#E9ABE1"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 445,
    y: 523,
    width: 3,
    height: 2,
    fill: "#E9ABE1"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 220,
    y: 523,
    width: 3,
    height: 2,
    fill: "#E9ABE1"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 455,
    y: 523,
    width: 3,
    height: 2,
    fill: "#E9ABE1"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 209,
    y: 563,
    width: 3,
    height: 2,
    fill: "#E9ABE1"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 288,
    y: 562,
    width: 3,
    height: 2,
    fill: "#E9ABE1"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 602,
    y: 783,
    width: 7,
    height: 7,
    fill: "#E9ABE1"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 1,
    transform: "matrix(1 0 0 -1 602 800)",
    fill: "#E9ABE1"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 1,
    transform: "matrix(1 0 0 -1 602 804)",
    fill: "#E9ABE1"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 287,
    y: 518,
    width: 3,
    height: 2,
    fill: "#E9ABE1"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 364,
    y: 518,
    width: 3,
    height: 2,
    fill: "#E9ABE1"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 365,
    y: 563,
    width: 3,
    height: 2,
    fill: "#E9ABE1"
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 606,
    width: 9,
    height: 2,
    fill: "#E9ABE1"
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 207,
    y: 651,
    width: 9,
    height: 2,
    fill: "#E9ABE1"
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 2,
    transform: "matrix(-1 0 0 1 1209 34)",
    fill: "#E9ABE1"
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 2,
    transform: "matrix(-1 0 0 1 974 34)",
    fill: "#E9ABE1"
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 2,
    transform: "matrix(-1 0 0 1 1199 34)",
    fill: "#E9ABE1"
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 2,
    transform: "matrix(-1 0 0 1 964 34)",
    fill: "#E9ABE1"
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 2,
    transform: "matrix(-1 0 0 1 1209 39)",
    fill: "#E9ABE1"
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 2,
    transform: "matrix(-1 0 0 1 974 39)",
    fill: "#E9ABE1"
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 2,
    transform: "matrix(-1 0 0 1 1199 39)",
    fill: "#E9ABE1"
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 2,
    transform: "matrix(-1 0 0 1 964 39)",
    fill: "#E9ABE1"
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 2,
    transform: "matrix(-1 0 0 1 1210 79)",
    fill: "#E9ABE1"
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 2,
    transform: "matrix(-1 0 0 1 1131 78)",
    fill: "#E9ABE1"
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 7,
    transform: "matrix(-1 0 0 1 817 299)",
    fill: "#E9ABE1"
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    x: 817,
    y: 316,
    width: 3,
    height: 1,
    transform: "rotate(180 817 316)",
    fill: "#E9ABE1"
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    x: 817,
    y: 320,
    width: 3,
    height: 1,
    transform: "rotate(180 817 320)",
    fill: "#E9ABE1"
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 2,
    transform: "matrix(-1 0 0 1 1132 34)",
    fill: "#E9ABE1"
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 2,
    transform: "matrix(-1 0 0 1 896 431)",
    fill: "#E9ABE1"
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 2,
    transform: "matrix(-1 0 0 1 742 432)",
    fill: "#E9ABE1"
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 2,
    transform: "matrix(-1 0 0 1 1055 34)",
    fill: "#E9ABE1"
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 2,
    transform: "matrix(-1 0 0 1 819 431)",
    fill: "#E9ABE1"
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 2,
    transform: "matrix(-1 0 0 1 665 432)",
    fill: "#E9ABE1"
  })), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 2,
    transform: "matrix(-1 0 0 1 1054 79)",
    fill: "#E9ABE1"
  })), _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 2,
    transform: "matrix(-1 0 0 1 1211 122)",
    fill: "#E9ABE1"
  })), _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 2,
    transform: "matrix(-1 0 0 1 1212 167)",
    fill: "#E9ABE1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtVideoArtifacts);
export default __webpack_public_path__ + "static/media/art-video-artifacts.272da64704105f28bd5fa40b0ef825f6.svg";
export { ForwardRef as ReactComponent };